import { FlexAligner, GroupedSelectOption, Select, SelectOption } from '@scaleaq/scaleui';
import { Controller, useForm } from 'react-hook-form';
import styled from 'styled-components';

import { Loader } from '@/components/Loader.tsx';
import { StyledModalContent } from '@/styles.ts';
import { WidgetConfigModalProps } from '@/types.ts';
import { colors, responsive } from '@/utils';

type FormValues<T> = {
  data: SelectOption<T>;
};

type OptionSelectModalProps<T> = WidgetConfigModalProps & {
  options: SelectOption<T>[] | GroupedSelectOption<SelectOption<T>>[];
  label: string;
  placeholder: string;
  isLoading: boolean;
};

export const OptionSelectModal = <T,>({
  onSave,
  options,
  label,
  placeholder,
  isLoading,
}: OptionSelectModalProps<T>) => {
  const { control } = useForm<FormValues<T>>();

  return (
    <StyledModalContent>
      <Loader render={isLoading} />
      <FlexAligner direction='column' gap='1.25rem'>
        <Controller
          control={control}
          name='data'
          render={({ field: { onChange, value } }) => (
            <SelectWrapper>
              <Select
                label={label}
                isClearable
                options={options}
                onChange={selected => {
                  onChange(selected);
                  onSave(selected?.value);
                }}
                placeholder={placeholder}
                value={value}
                style={{
                  color: colors.text.neutral[100],
                  fontFamily: responsive.font.family.body,
                  fontWeight: responsive.font.weight.regular,
                  fontSize: responsive.font.size.medium,
                }}
              />
            </SelectWrapper>
          )}
        />
      </FlexAligner>
    </StyledModalContent>
  );
};

const SelectWrapper = styled(FlexAligner)`
  min-width: 15.625rem;

  div:first-of-type {
    width: 100%;
  }
`;
